import type { ModulePermissionShape } from "@/types/permissions";

export const userPermissionKeys = [
  "users_list",
  "users_impersonate",
  "users_deactivate_account",
  "users_activate_account",
  "users_password_reset",
] as const;

export type UserPermissions = ModulePermissionShape<typeof userPermissionKeys>;
